/**
 * tvPlannedOrderModule 电视-串联单-编辑页
 * description:  电视-串联单-编辑页
 * author: Qian.qianchen 2019-04-04
 */
'use strict';
angular.module('iwoPlannedOrderEditModule', ['iwoQuoteManuscriptModule', 'iwoPlannedOrderInfoEditModule']).controller('iWoPlannedOrdeEditCtrl', [
    '$scope',
    'myManuscriptService',
    'initeditctrBtnsService',
    'trsHttpService',
    '$stateParams',
    '$q',
    '$validation',
    'editIsLock',
    'storageListenerService',
    '$state',
    '$timeout',
    'modalDialog',
    'editingCenterService',
    '$window',
    'trsPrintService',
    'localStorageService',
    'trsspliceString',
    function(
        $scope,
        myManuscriptService,
        initeditctrBtnsService,
        trsHttpService,
        $stateParams,
        $q,
        $validation,
        editIsLock,
        storageListenerService,
        $state,
        $timeout,
        modalDialog,
        editingCenterService,
        $window,
        trsPrintService,
        localStorageService,
        trsspliceString
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                plannedOrderFormError: [],
                plannedOrderDocSaveMethod: ['savePersonalChuanLianDoc', 'saveReceivedChuanLianDoc'],
                plannedOrderDocSubmitMethod: ['PersonalSubmitDoc', 'ReceivedSubmitDoc'],
                btnRights: {},
                sourceid: '',
                serviceid: {
                    '15': 'mlf_tv',
                    '16': 'mlf_broadcast',
                },
                fusionServiceid: {
                    '15': 'mlf_fusiontv',
                    '16': 'mlf_fusionbroadcast',
                },
                oralSeedingMethodsname: {
                    '15': 'exportTvKouboToTXTFile',
                    '16': 'exportKouboToTXTFile',
                },
                titleMethodsname: {
                    '15': 'exportTVTitleExcel',
                    '16': 'exportTitleExcel',
                },
            };
            $scope.data = {
                userName: '',
                METADATAID: $stateParams.iwometadataid,
                selectedArray: [],
                printResult: [],
            };
            initBtnRights();
            listenStorage();
            emitCloseWindow();
        }

        /**
         * [initBtnRights description] 初始化按钮权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            var methodnameArray = ['iwo.personal', 'iwo.received'];
            initeditctrBtnsService.initIwoData(methodnameArray[$stateParams.iwoplatform]).then(function(data) {
                data.forEach((item, index) => {
                    $scope.status.btnRights[item.OPERNAME.split('.')[2]] = true;
                });
            });
        }

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function() {
            //     localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $stateParams.iwometadataid }));
            // };
            editingCenterService.allAppCloseWindow($scope, {typeName: 'iwo', saveLocal: false});
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            queryChannelForMetadataid().then(function() {
                return getPlannedOrderData()
                    .then(function() {
                        return getQuoteManuscript();
                    })
                    .then(function() {
                        getTotalTime();
                    });
            });
        }

        /**
         * [queryChannelForMetadataid 查询串联单所属渠道]
         * @return {[type]} [description]
         */
        function queryChannelForMetadataid() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryDocMediaType',
                ObjectId: $stateParams.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.sourceid = data.MSG;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenIwo(function() {
                initData();
                storageListenerService.removeListener('iwo');
            }, $scope);
        }

        /**
         * [getPlannedOrderData description] 获取串联单数据
         * @return {[type]} [description]
         */
        function getPlannedOrderData() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.status.fusionServiceid[$scope.status.sourceid],
                methodname: 'getVirtualChuanLianDoc',
                SourceDocId: $scope.data.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.plannedOrderData = data;
                document.title = data.TITLE;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getQuoteManuscript description] 获取引用的广电广电文稿数据
         * @return {[type]} [description]
         */
        function getQuoteManuscript() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: 'queryQuoteDocListsToJSON',
                SeriesDocId: $scope.data.plannedOrderData.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.quoteManuscirptData = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getTotalTime description] 获取总时长
         * @return {[type]} [description]
         */
        function getTotalTime() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: 'getQuoteDocsTotalTime',
                SeriesDocId: $scope.data.plannedOrderData.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.totalTime = JSON.parse(data);
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [saveBasicDoc description] iwo基础稿保存
         * @return {[type]} [description]
         */
        function saveBasicDoc() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: $state.params.fromType ? 'saveDeptNews' : $scope.status.plannedOrderDocSaveMethod[$stateParams.iwoplatform],
                METADATAID: $scope.data.METADATAID,
                QUOTECHNLID: $scope.data.plannedOrderData.QUOTECHNLID,
                PREDATE: $scope.data.plannedOrderData.PREDATE,
                DeptmentalDocId: $state.params.departmentaldocid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [saveTvDoc description] 电视串联单保存
         * @return {[type]} [description]
         */
        function saveTvDoc() {
            var defer = $q.defer();
            var list = angular.copy($scope.data.plannedOrderData);
            list.serviceid = $scope.status.fusionServiceid[$scope.status.sourceid];
            list.methodname = 'saveChaunLianDoc';
            list.SOURCEDOCID = $scope.data.METADATAID;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function(data) {
                $scope.data.plannedOrderData.METADATAID = data.METADATAID;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.plannedOrderForm.$error) {
                errorArray.push(error);
            }
            $scope.status.plannedOrderFormError = $scope.status.plannedOrderFormError == undefined ? [] : $scope.status.plannedOrderFormError;
            if ($scope.status.plannedOrderFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.plannedOrderFormError = errorArray;
            }
            return $scope.status.plannedOrderFormError; // 返回
        };

        /**
         * [selectAll description] 全选/取消全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length == $scope.data.quoteManuscirptData.length && $scope.data.quoteManuscirptData.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = $scope.data.quoteManuscirptData;
            }
        };

        /**
         * [singleSelect description] 选择/取消选择
         * @param  {[type]} item [description] 广电文稿
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            if ($scope.data.selectedArray.indexOf(item) > -1) {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
        };

        /**
         * [addNewManuscript description]添加空白条目
         */
        $scope.addNewManuscript = function() {
            var routerParams = {
                iwoplatform: 0,
                isfromplannedorder: true,
                iwoplannedmetadataid: $stateParams.iwometadataid,
                seriesdocid: $scope.data.METADATAID,
                trench: 'iwo',
                sourceid: $scope.status.sourceid,
            };
            $scope.status.newUrl = $state.href('iwobroadcasttvmanuscript', routerParams);
        };

        /**
         * [deleteManuscript description] 删除已引用广电文稿
         * @return {[type]} [description]
         */
        $scope.deleteManuscript = function() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: 'removeQuoteDocs',
                QuoteRelationIds: $scope.data.selectedArray
                    .map(function(item) {
                        return item.DOCQUOTERELATIONID;
                    })
                    .join(','),
            };
            modalDialog.confirmModal(
                '选中' + $scope.data.selectedArray.length + '篇稿件',
                '删除将不可恢复，是否继续？',
                function() {
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post', false).then(function(dataC) {
                        if (dataC.ISSUCCESS) {
                            modalDialog.alertType('', '删除成功', 'success', false, function() {
                                editIsLock.lockDraft($stateParams.iwometadataid);
                                getQuoteManuscript();
                                $scope.data.selectedArray = [];
                            });
                        }
                    });
                },
                function() {
                    editIsLock.lockDraft($stateParams.iwometadataid);
                }
            );
        };

        /**
         * [getBroadcast description] 提取口播
         * @return {[type]} [description]
         */
        $scope.getBroadcast = function() {
            var metadataids = '',
                url = '';
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: $scope.status.oralSeedingMethodsname[$scope.status.sourceid],
                seriesDocId: $scope.data.plannedOrderData.METADATAID,
            };
            if ($scope.data.selectedArray.length > 0) {
                metadataids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                params.metadataIds = metadataids;
                url = '/wcm/mlfcenter.do?' + $.param(params);
            } else {
                url = '/wcm/mlfcenter.do?' + $.param(params);
            }
            window.open(url);
        };

        /**
         * [getTitle description] 提取标题
         * @return {[type]} [description]
         */
        $scope.getTitle = function() {
            var metadataids = '',
                url = '';
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: $scope.status.titleMethodsname[$scope.status.sourceid],
                seriesDocId: $scope.data.plannedOrderData.METADATAID,
            };
            if ($scope.data.selectedArray.length > 0) {
                metadataids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                params.metadataIds = metadataids;
                url = '/wcm/mlfcenter.do?' + $.param(params);
            } else {
                url = '/wcm/mlfcenter.do?' + $.param(params);
            }
            window.open(url);
        };

        /**
         * [save description] 保存方法
         * @param   {[type]}  type  [type description]
         * @return  {[type]}        [return description]
         */
        $scope.save = function(type) {
            type = angular.isDefined(type) ? type : true;
            var defer = $q.defer();
            $scope.plannedOrderForm.$pending = {};
            $validation.validate($scope.plannedOrderForm).success(function() {
                saveBasicDoc().then(function(data) {
                    $scope.data.METADATAID = data.METADATAID;
                    saveTvDoc().then(
                        function() {
                            if (type) {
                                editIsLock.lockDraft($stateParams.iwometadataid);
                                storageListenerService.addListenerToIwo('plannerOrderSaved');
                                $stateParams.iwochnldocid = data.CHNLDOCID;
                                $stateParams.iwometadataid = data.METADATAID;
                                $state.transitionTo($state.current, $stateParams, {
                                    reload: false,
                                });
                                $timeout(function() {
                                    modalDialog.saveModel('保存成功', '', 'success');
                                    $scope.status.showplannedOrderInfo = false;
                                }, 500);
                            }
                            defer.resolve();
                        },
                        function(msg) {
                            defer.reject(msg);
                        }
                    );
                });
            });
            return defer.promise;
        };

        /**
         * [close description]页面关闭
         * @return {[type]} [description]
         */
        $scope.close = function() {
            editingCenterService.closeWinow($scope.plannedOrderForm.$dirty, false).then(
                function() {
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                },
                function() {
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                }
            );
        };

        /**
         * [submit description] 提交
         * @return {[type]} [description]
         */
        $scope.submit = function() {
            $scope.save(false).then(function() {
                modalDialog.alertType(
                    '',
                    '确认提交到' + $scope.data.plannedOrderData.QUOTECHNLDESC + '?',
                    'ask',
                    true,
                    function() {
                        var defer = $q.defer();
                        var params = {
                            serviceid: 'mlf_fusionmyrelease',
                            methodname: $scope.status.plannedOrderDocSubmitMethod[$stateParams.iwoplatform],
                            MetaDataIds: $scope.data.METADATAID,
                            CHNLDOCIDS: $stateParams.iwochnldocid,
                            // TvWenGao: $scope.data.plannedOrderData.CHANNELID
                        };
                        // $scope.status.sourceid == 15 ? params.TvWenGao = $scope.data.plannedOrderData.CHANNELID : params.BroadCastWenGao = $scope.data.plannedOrderData.CHANNELID;
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            modalDialog.alertType('', '提交成功', 'success', false, function() {
                                storageListenerService.addListenerToIwo('plannerOrderSubmit');
                                var opened = $window.open('about:blank', '_self');
                                opened.close();
                            });
                        });
                    },
                    function() {}
                );
            });
        };

        /**
         * [refreshData description] 数据刷新
         * @return {[type]} [description]
         */
        $scope.refreshManuscriptData = function() {
            getQuoteManuscript().then(function() {
                getTotalTime();
            });
        };

        /**
         * [dragoverCallback description;允许拖拽]
         */
        $scope.dragoverCallback = function(event, index, external, type) {
            return true;
        };

        /**
         * [dragStart description;拖拽开始]
         */
        $scope.dragStart = function(event, item, index) {
            $scope.status.dragStartIndex = index;
            // $scope.status.dragStartItem = item;
        };

        /**
         * [dragStdropCallbackart description;拖拽结束]
         */
        $scope.dropCallback = function(event, index, item, external, type, allowedType) {
            if ($scope.status.dragStartIndex == index) {
                return;
            }
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: 'orderQuoteDocForDaiBianEdit',
                startDocId: $scope.data.quoteManuscirptData[$scope.status.dragStartIndex].METADATAID,
                targetDocId:
                    $scope.status.dragStartIndex > index
                        ? $scope.data.quoteManuscirptData[index].METADATAID
                        : $scope.data.quoteManuscirptData[index - 1].METADATAID,
                seriesDocId: $scope.data.plannedOrderData.METADATAID,
                siteId: $scope.data.plannedOrderData.WEBSITEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                getQuoteManuscript();
            });
        };

        /**
         * [refreshData description] 数据刷新
         * @return {[type]} [description]
         */
        $scope.refreshPlannedOrderData = function() {
            console.log($scope.data.plannedOrderData);
        };

        /**
         * [itemInit description] 广电文稿对象数据初始化
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.itemInit = function(item) {
            item.component = item.CONTENTSTRUCTURE == '' ? [] : item.CONTENTSTRUCTURE.split(',');
            item.status = !item.DUBBINGSTATUS ? '未配音' : '已配音';
        };

        /**
         * [isLockEdit description] 判断广电文稿是否锁定，未锁定进入编辑状态
         * @param  {[type]}  item [description]
         * @return {Boolean}      [description]
         */
        $scope.isLockEdit = function(item) {
            editIsLock.isLock(item, 15).then(function(data) {
                var editPath = 'televisionmanuscript';
                var editParams = {
                    tvchannelid: item.CHANNELID,
                    tvchnldocid: item.CHNLDOCID,
                    tvmetadataid: item.METADATAID,
                    tvsiteid: item.SITE,
                    tvplatform: 2,
                };
                var editUrl = $state.href(editPath, editParams);
                if (data.ISLOCK == 'false') {
                    $window.open(editUrl);
                } else {
                    editIsLock.checkUnlockPermissions(item, data).then(function() {
                        $window.open(editUrl);
                    });
                }
            });
        };

        /**
         * [printBtn 打印]
         * @return {[type]} [description]
         */
        $scope.printSeriessheet = function() {
            $scope.status.isESSearch = false;
            // if (checkDraftType($scope.status.draftType.subject)) {
            //     modalDialog.alertType("所选稿件中有专题稿，无法打印", '', "error", false);
            //     return;
            // }
            // angular.forEach($scope.data.selectedArray, function(value, key) {
            getSeriessSheetDetail().then(function(data) {
                requestPrintData();
            });
            // });
        };

        /**
         * [requestData 获取详情]
         * @return {[type]} [description]
         */
        function getSeriessSheetDetail() {
            var defer = $q.defer();
            var params = {
                serviceid: $scope.status.fusionServiceid[$scope.status.sourceid],
                methodname: 'getVirtualChuanLianDoc',
                SourceDocId: $stateParams.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.detail = data;
                defer.resolve();
            });
            return defer.promise;
        }

        // /**
        //  * [requestPrintVersion 打印流程请求]
        //  * @param  {[type]} item [description]
        //  * @return {[type]}      [description]
        //  */
        // function requestPrintVersion(item) {
        //     var defer = $q.defer();
        //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
        //         serviceid: "mlf_metadatalog",
        //         methodname: "query",
        //         MetaDataId: item.METADATAID
        //     }, 'get').then(function(data) {
        //         defer.resolve(data.DATA);
        //     });
        //     return defer.promise;
        // }

        /**
         * [requestPrintData 打印请求详情]
         * @param  {[type]} item    [description]
         * @param  {[type]} version [description]
         * @return {[type]}         [description]
         */
        function requestPrintData(flag, item) {
            var params;
            if (flag) {
                params = {
                    serviceid: $scope.status.serviceid[$scope.status.sourceid],
                    methodname: 'getWenGaoDoc',
                    MetaDataId: item.METADATAID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    var result = data;
                    // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    if ($scope.data.printResult.length == $scope.data.quoteManuscirptData.length) {
                        trsPrintService.trsTvPrintDocument($scope.data.printResult);
                        $scope.data.printResult = [];
                    }
                });
            } else {
                var result = $scope.data.detail;
                result.ITEMS = $scope.data.quoteManuscirptData;
                // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                // if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                trsPrintService.trsTvPrintDocument($scope.data.printResult);
                $scope.data.printResult = [];
            }
        }

        /**
         * [printAllManuscript 打印全部稿件]
         * @return {[type]} [description]
         */
        $scope.printAllManuscript = function() {
            if ($scope.data.quoteManuscirptData.length == 0) {
                modalDialog.alertType('该串联单没有关联广电文稿，暂时无法打印', '', 'warning', 'confirm');
                return;
            }
            $scope.status.isESSearch = false;
            // if (checkDraftType($scope.status.draftType.subject)) {
            //     modalDialog.alertType("所选稿件中有专题稿，无法打印", '', "error", false);
            //     return;
            // }
            angular.forEach($scope.data.quoteManuscirptData, function(value, key) {
                // getSeriessSheetDetail().then(function(data) {
                requestPrintData(true, value);
                // });
            });
        };

        /**
         * [refreshTime description] 总时长刷新
         * @return {[type]} [description]
         */
        $scope.refreshTime = function() {
            getTotalTime();
        };
        // 传稿(个人稿库+已收稿库)
        $scope.iWoTransfer = function() {
            $scope.save(false).then(function() {
                draft();
            });
        };
        // 保存并关闭
        $scope.savethenclose = function() {
            $scope.save(false).then(function() {
                window.close();
            });
        };
        // 传稿触发结束
        /**
         * [draft description]传稿函数
         *
         * @return  {[type]}  [return description]
         */
        function draft() {
            var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
            myManuscriptService.draft(
                '传稿',
                [
                    {
                        TITLE: '',
                        CHNLDOCID: $stateParams.iwochnldocid,
                        METADATAID: $stateParams.iwometadataid,
                        DOCTYPEID: 11,
                    },
                ],
                function() {
                    storageListenerService.addListenerToIwo('manuscriptPassed');
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                },
                function() {},
                menthod[$stateParams.iwoplatform]
            );
        }

        /**
         * [printThemeFlower 打印提花]
         * @return {[type]} [description]
         */
        $scope.printThemeFlower = function() {
            getChuanLianOfThemeFlower();
        };

        /**
         * [getChuanLianOfThemeFlower 打印提花]
         * @return {[type]} [description]
         */
        function getChuanLianOfThemeFlower() {
            var params = {
                serviceid: $scope.status.serviceid[$scope.status.sourceid],
                methodname: 'getChuanLianOfThemeFlower',
                metadataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                seriesDocId: $scope.data.plannedOrderData.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data[0].METADATA;
                result.CHUANLIANTIHUA = data[1].CHUANLIANTIHUA;
                result.TIHUASIZE = data[1].TIHUASIZE;
                $scope.data.printResult.push(result);
                trsPrintService.trsTvPrintDocument($scope.data.printResult, true);
                $scope.data.printResult = [];
            });
        }

        /**
         * [preview 详情页跳转]
         * @param  {[type]} doctype       [description]
         * @param  {[type]} iwometadataid [description]
         * @param  {[type]} iwochannelid  [description]
         * @param  {[type]} CHANNELID     [description]
         * @param  {[type]} item          [description]
         * @return {[type]}               [description]
         */
        $scope.preview = function(doctype, iwometadataid, iwochannelid, CHANNELID, item) {
            var routerParams, url;
            if ($scope.status.sourceid == 15) {
                storageListenerService.previewPageTurningStorage(
                    $scope.data.quoteManuscirptData,
                    'METADATAID,CHNLDOCID,DOCTYPEID',
                    'televisionPreview'
                ); // iwo
                routerParams = {
                    // iwoplatform: 0,
                    tvmetadataid: iwometadataid,
                    tvsiteid: item.SITE.SITEID,
                    tvplatform: item.DOCSTATUS == 1 || item.DOCSTATUS == 15 ? 0 : item.DOCSTATUS == 2 ? 1 : 2,
                    tvchannelid: CHANNELID,
                    // broadcastchannelid: iwochnldocid,
                    isfromplannedorder: true,
                };
                url = $state.href('manuscriptPreview', routerParams);
            } else {
                storageListenerService.previewPageTurningStorage(
                    $scope.data.quoteManuscirptData,
                    'METADATAID,CHNLDOCID,DOCTYPEID',
                    'broadcastPreview'
                ); // iwo
                routerParams = {
                    // iwoplatform: 0,
                    broadcastmetadataid: iwometadataid,
                    broadcastsiteid: item.SITE.SITEID,
                    broadcastplatform: item.DOCSTATUS == 1 || item.DOCSTATUS == 15 ? 0 : item.DOCSTATUS == 2 ? 1 : 2,
                    broadcastchannelid: CHANNELID,
                    // broadcastchannelid: iwochnldocid,
                    isfromplannedorder: true,
                };
                url = $state.href('broadcastmanuscriptPreview', routerParams);
            }
            item.url = url;
        };
    },
]);
